export const markerdata = [
    {
        title: '1',
        recycling: true,
        lat: 37.491776,
        lng: 127.054961,
    },
    {
        title: '3',
        recycling: true,
        lat: 37.487337,
        lng: 127.032718,
    },
    {
        title: '4',
        recycling: true,
        lat: 37.487152,
        lng: 127.032786,
    },
    {
        title: '5',
        recycling: true,
        lat: 37.486539,
        lng: 127.033071,
    },
    {
        title: '6',
        recycling: true,

        lat: 37.484813,
        lng: 127.034227,
    },
    {
        title: '7',
        recycling: true,
        lat: 37.469261,
        lng: 127.039737,
    },
    {
        title: '8',
        recycling: true,
        lat: 37.501206,
        lng: 127.036936,
    },
    {
        title: '9',
        recycling: true,
        lat: 37.513803,
        lng: 127.030809,
    },
    {
        title: '10',
        recycling: true,
        lat: 37.513803,
        lng: 127.030809,
    },
    {
        title: '11',
        recycling: true,
        lat: 37.514236,
        lng: 127.030563,
    },
    {
        title: '12',
        recycling: true,
        lat: 37.514843,
        lng: 127.030449,
    },
    {
        title: '13',
        recycling: true,
        lat: 37.518247,
        lng: 127.028915,
    },
    {
        title: '14',
        recycling: true,
        lat: 37.499159,
        lng: 127.051429,
    },
    {
        title: '15',
        recycling: true,
        lat: 37.488854,
        lng: 127.029693,
    },
    {
        title: '16',
        recycling: true,
        lat: 37.496676,
        lng: 127.054271,
    },
    {
        title: '17',
        recycling: true,
        lat: 37.497312,
        lng: 127.056149,
    },
    {
        title: '18',
        recycling: true,
        lat: 37.49649,
        lng: 127.062043,
    },
    {
        title: '19',
        recycling: true,
        lat: 37.495595,
        lng: 127.062546,
    },
    {
        title: '20',
        recycling: true,
        lat: 37.495677,
        lng: 127.066606,
    },
    {
        title: '21',
        recycling: true,
        lat: 37.496615,
        lng: 127.069403,
    },
    // 22 -25 are the cluster
    {
        title: '22',
        recycling: true,
        lat: 37.498595,
        lng: 127.068458,
    },
    {
        title: '23',
        recycling: true,
        lat: 37.499729,
        lng: 127.067951,
    },
    {
        title: '24',
        recycling: true,
        lat: 37.500427,
        lng: 127.067523,
    },
    {
        title: '25',
        recycling: true,
        lat: 37.501061,
        lng: 127.067132,
    },
    {
        title: '26',
        recycling: true,
        lat: 37.50166,
        lng: 127.066827,
    },
    {
        title: '27',
        recycling: true,
        lat: 37.514337,
        lng: 127.05968,
    },
    {
        title: '28',
        recycling: true,
        lat: 37.51393,
        lng: 127.059941,
    },
    {
        title: '29',
        recycling: false,
        lat: 37.511203,
        lng: 126.99881,
    },
    {
        title: '30',
        recycling: false,
        lat: 37.525596,
        lng: 126.992197,
    },
    {
        title: '31',
        recycling: false,
        lat: 37.530512,
        lng: 126.991273,
    },
    {
        title: '32',
        recycling: false,
        lat: 37.53227,
        lng: 126.98996,
    },
    {
        title: '33',
        recycling: false,
        lat: 37.547635,
        lng: 126.984144,
    },
    {
        title: '34',
        recycling: true,
        lat: 37.553005,
        lng: 127.00926,
    },
    {
        title: '35',
        recycling: true,
        lat: 37.550293,
        lng: 127.007639,
    },
    {
        title: '36',
        recycling: true,
        lat: 37.547727,
        lng: 127.006219,
    },
    {
        title: '37',
        recycling: true,
        lat: 37.540903,
        lng: 127.00307,
    },
    {
        title: '38',
        recycling: true,
        lat: 37.536409,
        lng: 127.005408,
    },
    {
        title: '39',
        recycling: false,
        lat: 37.532906,
        lng: 127.008182,
    },
    {
        title: '40',
        recycling: true,
        lat: 37.479702,
        lng: 127.043632,
    },
    {
        title: '41',
        recycling: true,
        lat: 37.482162,
        lng: 127.043078,
    },
    {
        title: '42',
        recycling: true,
        lat: 37.516229,
        lng: 127.019438,
    },
    {
        title: '43',
        recycling: true,
        lat: 37.530627,
        lng: 126.954482,
    },
    {
        title: '44',
        recycling: false,
        lat: 37.53249,
        lng: 127.060888,
    },
    {
        title: '45',
        recycling: false,
        lat: 37.504986,
        lng: 127.011363,
    },
    {
        title: '46',
        recycling: false,
        lat: 37.484903,
        lng: 127.016189,
    },
];
